"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDepositType = void 0;
var getDepositType = exports.getDepositType = function getDepositType(product) {
  return product.ProductFullName.toLowerCase().replace(/\W/g, '');
};